module.exports = __webpack_public_path__ + "img/not-available.bb9abcf.png";